<template>
  <roe-error-message
    :field="design.employer_other_integrated_base_percent_below"
  >
    <roe-percent-input
      v-model.number="
        design.$model.employer_other_integrated_base_percent_below
      "
    ></roe-percent-input>
    <label class="input-label-inside">%</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
export default {
  name: "RoeEmployerOtherIntegratedPercentBelowInput",
  components: { RoePercentInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
